/**************************************************
 * Nombre:       Tarjeta_Blog
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Chip, Grid, Typography} from "@mui/material";
import {COLORTEXTO} from "../../Constantes";
import {ArrowForward} from '@mui/icons-material'
import {useNavigate} from "react-router";

const Tarjeta_Blog = ({item}) => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img} width="100%" height="auto" style={{borderRadius: 20}}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#ffffff',
                    p: 3,
                    borderBottomRightRadius: 20,
                    borderBottomLeftRadius: 20,
                    mt: -5
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -5}}>
                    <Chip color={'primary'} label={item.categorias[0]} sx={{fontWeight: 600}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Typography sx={{fontSize: 20, fontWeight: 800, color: COLORTEXTO, lineHeight: 1.2}}>
                        {item.nombre}
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                    <Button
                        onClick={() => navigate('/Blog/' + item.id)}
                        variant={'text'} endIcon={<ArrowForward/>}
                        sx={{px: 0, fontSize: 14, color: COLORTEXTO}}
                    >LEER MAS </Button>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Blog